export function getQueryKey(search) {
  return ['allProducts', search];
}
